import { ERRORTYPE } from 'utils/validation';
import { IdentityCheckFormData, IdentityCheckErrorData } from './types';

const validation = ({ onlineAcceptance }: IdentityCheckFormData): IdentityCheckErrorData => {
  return !onlineAcceptance ? { onlineAcceptance: ERRORTYPE.REQUIRED } : {};
};

export default validation;
